import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'svg-frontends-page-logout',
	styleUrls: ['./page-logout.component.scss'],
	templateUrl: './page-logout.component.html',
	standalone: false,
})
export class PageLogoutComponent {}
